import { IAccountInfo } from "@Models/interfaces/account";
import { HiMiniStar } from "react-icons/hi2";
// @ts-ignore
import modalStyle from "./FeatureReached.module.css";
//@ts-ignore
import { ButtonWithoutIcon, IconWrapper } from "@viuti/recursos";
import {
  featureMessages,
  FeatureType,
} from "../../utilities/messages";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

export interface IFeatureReachedProps {
  accountInfo: IAccountInfo;
  counter: number;
  type: FeatureType;
  onClose?: () => void;
}

const FeatureReached = ({
  accountInfo,
  counter,
  type,
  onClose,
}: IFeatureReachedProps) => {
  const getStartViewFromToken = () => {
    try {
      const token = localStorage.getItem("access_token");
      if (token) {
        const tokenData = JSON.parse(atob(token.split(".")[1]));
        return tokenData.StartView || "/estadisticas";
      }
    } catch (error) {
      console.error("Error al obtener StartView del token:", error);
    }
    return "/estadisticas";
  };

  const getDescription = () => {
    const planName = accountInfo.plan.name;
    const description = featureMessages[type];
    const message = description[planName] || description.Emprendedor;
    const html = message
      .replace("{accountInfo.plan.name}", planName)
      .replace("{counter}", String(counter));

    return sanitizeHtml(html);
  };

  return (
    <div className={modalStyle.modal__access__denied}>
      <div className={modalStyle.modal__access__denied__icon__container}>
        <span className={modalStyle.modal__access__denied__icon}>
          <IconWrapper icon={HiMiniStar} size={48} color="#FFC700" />
        </span>
      </div>
      <h2 className={modalStyle.modal__access__denied__subtitle}>
        Esta funcionalidad no está disponible en el plan{" "}
        <b>{accountInfo.plan.name}</b>.
      </h2>

      <p
        className={modalStyle.modal__access__denied__description}
        dangerouslySetInnerHTML={{ __html: getDescription() }}
      />

      <div className={modalStyle.buttons__container}>
        <ButtonWithoutIcon
          isPrimary={false}
          textBttn="Cancelar"
          handleClick={() => {
            if (type === "marketing") {
              window.location.replace(getStartViewFromToken());
            } else {
              onClose ? onClose() : window.location.reload();
            }
          }}
        />
        <ButtonWithoutIcon
          isPrimary
          textBttn="Mejorar mi plan"
          handleClick={() =>
            window.location.replace("/mi-cuenta/gestionar-plan")
          }
        />
      </div>
    </div>
  );
};

export default FeatureReached;
